/*global $, refreshSuitInfo*/
/*eslint camelcase: [2, {properties: "never"}]*/
$(function () {
    "use strict";
    var productInfoForm = $("#product_info_form");

    applySelectionsFromLocalStorage();

    $("#jacket_measurement_sizechart, #trouser_measurement_sizechart").on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).tab("show");
    });

    productInfoForm.on("click", "a.product_option", function (e) {
        e.preventDefault();
        // e.stopPropagation();
        var selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
        refreshSuitInfo(this.id, false, selectionHighlightsActive);
    });

    productInfoForm.on("click", "a.clear_selections", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
        refreshSuitInfo("0", true, selectionHighlightsActive);
    });

    function applySelectionsFromLocalStorage() {
        var categorySettings;
        var selectionHighlightsActive;

        var jacketSizeId, jacketSecondarySizeId, trouserSizeId, trouserSecondarySizeId;
        if (!Modernizr.localstorage) {
            return false;
        }

        /**
         * @var {{ trousers:array, jackets:array }} categorySettings
         */
        categorySettings = JSON.parse(localStorage.getItem("categorySettings"));

        if (!categorySettings) {
            return false;
        }

        //first use suit category for jacket sizes
        if(categorySettings.hasOwnProperty('mens-suits')) {
            if (categorySettings['mens-suits'].hasOwnProperty("sizeId")) {
                jacketSizeId = parseInt(categorySettings['mens-suits'].sizeId);
            }

            if (categorySettings['mens-suits'].hasOwnProperty("secondarySizeId")) {
                jacketSecondarySizeId = parseInt(categorySettings['mens-suits'].secondarySizeId);
            }
        }

        //if not jacket sizes check jackets category
        if(categorySettings.hasOwnProperty('jackets')) {
            if (!jacketSizeId) {
                if (categorySettings.jackets.hasOwnProperty("sizeId")) {
                    jacketSizeId = parseInt(categorySettings.jackets.sizeId);
                }
            }

            if (!jacketSecondarySizeId) {
                if (categorySettings.jackets.hasOwnProperty("secondarySizeId")) {
                    jacketSecondarySizeId = parseInt(categorySettings.jackets.secondarySizeId);
                }
            }
        }

        if(categorySettings.hasOwnProperty('trousers')) {
            if (categorySettings.trousers.hasOwnProperty("sizeId")) {
                trouserSizeId = parseInt(categorySettings.trousers.sizeId);
            }

            if (categorySettings.trousers.hasOwnProperty("secondarySizeId")) {
                trouserSecondarySizeId = parseInt(categorySettings.trousers.secondarySizeId);
            }
        }



        //if there's not size selected (via cookie at php), and lc size is available, apply it
        if( jacketSizeId && ! $("#jacket_sizes a.active").length) {
            if( $("#jacket_sizes #jacket-size-"+jacketSizeId).length ) {
                selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
                refreshSuitInfo("jacket-size-"+jacketSizeId, false, selectionHighlightsActive);
            }
        }

        //in theory they shouldn't arrive at a product page with a conflicting size and secondary size because the product
        //wouldn't have shown in the list, so we shouldn't have to worry about race conditions or applying incompatible
        //combinations
        //if there's not size selected (via cookie at php), and lc size is available, apply it
        if( jacketSecondarySizeId && ! $("#jacket_secondary_sizes a.active").length) {
            if( $("#jacket_secondary_sizes #jacket-secondary-size-"+jacketSecondarySizeId).length ) {
                selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
                refreshSuitInfo("jacket-secondary-size-"+jacketSecondarySizeId, false, selectionHighlightsActive);
            }
        }

        //if there's not size selected (via cookie at php), and lc size is available, apply it
        if( trouserSizeId && ! $("#trouser_sizes a.active").length) {
            if( $("#trouser_sizes #trouser-size-"+trouserSizeId).length ) {
                selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
                refreshSuitInfo("trouser-size-"+trouserSizeId, false, selectionHighlightsActive);
            }
        }

        //in theory they shouldn't arrive at a product page with a conflicting size and secondary size because the product
        //wouldn't have shown in the list, so we shouldn't have to worry about race conditions or applying incompatible
        //combinations
        //if there's not size selected (via cookie at php), and lc size is available, apply it
        if( trouserSecondarySizeId && ! $("#trouser_secondary_sizes a.active").length) {
            if( $("#trouser_secondary_sizes #trouser-secondary-size-"+trouserSecondarySizeId).length ) {
                selectionHighlightsActive = $(".inactive-buy").text() === "Please Make Selections";
                refreshSuitInfo("trouser-secondary-size-"+trouserSecondarySizeId, false, selectionHighlightsActive);
            }
        }
    }

});
